module.exports = __webpack_public_path__ + "static/media/Repair_Refill.de33f1ef.png";